module.exports = __webpack_public_path__ + "static/media/icocalendar.3f7014b5.svg";